import { type ElementType, type FC } from 'react';
import { Menu } from '@mantine/core';
import { type ItemType } from './types';

type ItemProps = Omit<ItemType, 'dividerBefore'>;

export const Item: FC<ItemProps> = ({ title, icon, onClick, component, componentProps }) => {
    return (
        <Menu.Item
            leftSection={icon}
            title={title}
            onClick={onClick}
            renderRoot={
                component
                    ? (props) => {
                          const Component = component as ElementType;

                          return (
                              <Component
                                  {...props}
                                  {...componentProps}
                              />
                          );
                      }
                    : undefined
            }
        >
            {title}
        </Menu.Item>
    );
};
